import { defineMessages } from 'react-intl-next';

export const messages: {
	alertIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationModalCancel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationModalConfirm: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationModalDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationModalTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorDefaultDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorDefaultHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	alertIcon: {
		id: 'admin-hub-sidebar.error-section.alert-icon',
		defaultMessage: 'Alert icon',
		description: 'Aria label for the alert icon',
	},
	errorDefaultHeader: {
		id: 'admin-hub-sidebar-next.error.default.header',
		defaultMessage: "We're having trouble loading this content.",
		description: 'The default error header text.',
	},
	errorDefaultDescription: {
		id: 'admin-hub-sidebar-next.error.default.description',
		defaultMessage: 'Something went wrong on our end. Close the panel or try again.',
		description: 'The default error description text.',
	},
	confirmationModalTitle: {
		id: 'admin-hub-sidebar-next.confirmation-modal.title',
		defaultMessage: 'You have unsaved changes',
		description: 'The title of the confirmation modal.',
	},
	confirmationModalDescription: {
		id: 'admin-hub-sidebar-next.confirmation-modal.description',
		defaultMessage: 'You’re about to close the sidebar which will discard your unsaved changes.',
		description: 'The description of the confirmation modal.',
	},
	confirmationModalCancel: {
		id: 'admin-hub-sidebar-next.confirmation-modal.cancel',
		defaultMessage: 'Cancel',
		description: 'The cancel button text of the confirmation modal.',
	},
	confirmationModalConfirm: {
		id: 'admin-hub-sidebar-next.confirmation-modal.confirm',
		defaultMessage: 'Discard changes',
		description: 'The confirm button text of the confirmation modal.',
	},
});
